// За полной документацией по API, включая примеры кода, зайдите на http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function box1_click(event) {
	//Add your code for this event here: 
}